export const translations = {
  en: {
    // Header
    brand: "Parfumerie Artisanale",
    tagline: "Craft Your Signature Scent",
    
    // Main UI
    yourFormula: "Your Formula",
    emptyBottle: "Begin your creation",
    emptyBottleHint: "Select an essence below",
    totalVolume: "Total Volume",
    ml: "ml",
    
    // Actions
    startOver: "Start Over",
    saveCreation: "Save Creation",
    cancel: "Cancel",
    save: "Save",
    
    // Dialog
    saveTitle: "Name Your Creation",
    saveDescription: "Give your unique fragrance a name to remember it by.",
    perfumeName: "Perfume Name",
    perfumeNamePlaceholder: "e.g., Midnight Garden",
    savedSuccess: "Your creation has been saved",
    
    // Essences section
    essencesTitle: "Essences",
    selectEssence: "Select an essence to add",
    swipeHint: "Swipe to explore",
    
    // Essence names
    essences: {
      rose: "Rose",
      sandalwood: "Sandalwood",
      bergamot: "Bergamot",
      vanilla: "Vanilla",
      oud: "Oud",
      jasmine: "Jasmine",
      musk: "Musk",
      cedarwood: "Cedarwood"
    },
    
    // Essence descriptions
    essenceDescriptions: {
      rose: "Romantic floral",
      sandalwood: "Warm woody",
      bergamot: "Fresh citrus",
      vanilla: "Sweet creamy",
      oud: "Deep exotic",
      jasmine: "Sensual white floral",
      musk: "Soft animalic",
      cedarwood: "Dry woody"
    },
    
    // Notes
    notes: {
      top: "Top Note",
      heart: "Heart Note", 
      base: "Base Note"
    },
    
    // Saved perfumes
    savedPerfumes: "Saved Creations",
    noSavedPerfumes: "No saved creations yet",
    loadPerfume: "Load",
    deletePerfume: "Delete",
    
    // Tooltips
    dropAdded: "drop added",
    dropsAdded: "drops added",
  },
  
  jp: {
    // Header
    brand: "調香工房",
    tagline: "あなただけの香りを創る",
    
    // Main UI
    yourFormula: "調合レシピ",
    emptyBottle: "創作を始める",
    emptyBottleHint: "下のエッセンスを選択",
    totalVolume: "総量",
    ml: "ml",
    
    // Actions
    startOver: "やり直す",
    saveCreation: "保存する",
    cancel: "キャンセル",
    save: "保存",
    
    // Dialog
    saveTitle: "香水に名前を付ける",
    saveDescription: "あなたの作品に特別な名前を付けてください。",
    perfumeName: "香水の名前",
    perfumeNamePlaceholder: "例：真夜中の庭",
    savedSuccess: "作品を保存しました",
    
    // Essences section
    essencesTitle: "エッセンス",
    selectEssence: "エッセンスを選んで追加",
    swipeHint: "スワイプで探索",
    
    // Essence names
    essences: {
      rose: "ローズ",
      sandalwood: "サンダルウッド",
      bergamot: "ベルガモット",
      vanilla: "バニラ",
      oud: "ウード",
      jasmine: "ジャスミン",
      musk: "ムスク",
      cedarwood: "シダーウッド"
    },
    
    // Essence descriptions
    essenceDescriptions: {
      rose: "ロマンティックな花",
      sandalwood: "温かみのある木",
      bergamot: "爽やかな柑橘",
      vanilla: "甘くクリーミー",
      oud: "深くエキゾチック",
      jasmine: "官能的な白い花",
      musk: "柔らかな動物香",
      cedarwood: "乾いた木の香り"
    },
    
    // Notes
    notes: {
      top: "トップノート",
      heart: "ハートノート",
      base: "ベースノート"
    },
    
    // Saved perfumes
    savedPerfumes: "保存した作品",
    noSavedPerfumes: "保存した作品はまだありません",
    loadPerfume: "読み込む",
    deletePerfume: "削除",
    
    // Tooltips
    dropAdded: "滴追加",
    dropsAdded: "滴追加",
  }
};

export const essenceData = [
  {
    id: 'rose',
    colorVar: '--essence-rose',
    color: 'hsl(350, 70%, 80%)',
    noteType: 'heart',
    mlPerDrop: 2
  },
  {
    id: 'sandalwood',
    colorVar: '--essence-sandalwood', 
    color: 'hsl(25, 50%, 35%)',
    noteType: 'base',
    mlPerDrop: 2
  },
  {
    id: 'bergamot',
    colorVar: '--essence-bergamot',
    color: 'hsl(85, 60%, 65%)',
    noteType: 'top',
    mlPerDrop: 2
  },
  {
    id: 'vanilla',
    colorVar: '--essence-vanilla',
    color: 'hsl(45, 70%, 75%)',
    noteType: 'base',
    mlPerDrop: 2
  },
  {
    id: 'oud',
    colorVar: '--essence-oud',
    color: 'hsl(30, 70%, 30%)',
    noteType: 'base',
    mlPerDrop: 2
  },
  {
    id: 'jasmine',
    colorVar: '--essence-jasmine',
    color: 'hsl(55, 80%, 85%)',
    noteType: 'heart',
    mlPerDrop: 2
  },
  {
    id: 'musk',
    colorVar: '--essence-musk',
    color: 'hsl(30, 20%, 45%)',
    noteType: 'base',
    mlPerDrop: 2
  },
  {
    id: 'cedarwood',
    colorVar: '--essence-cedarwood',
    color: 'hsl(15, 55%, 40%)',
    noteType: 'base',
    mlPerDrop: 2
  }
];
